import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

interface HeadlineProps {
  classNames?: string;
  extraElement?: React.ReactNode;
  shouldBeH1?: boolean;
  smallerFont?: boolean;
  subTitle?: React.ReactNode;
  title?: string | React.ReactElement;
  titleClassName?: string;
}

const renderTitle = ({
  title,
  attributes,
  shouldBeH1,
}: {
  attributes?: React.HTMLAttributes<HTMLHeadingElement>;
  title: React.ReactNode;
  shouldBeH1: boolean;
}): React.ReactNode => {
  return shouldBeH1 ? <h1 {...attributes}>{title}</h1> : <h2 {...attributes}>{title}</h2>;
};

const Headline: React.FC<HeadlineProps> = ({
  classNames,
  extraElement,
  shouldBeH1 = true,
  smallerFont = false,
  subTitle,
  title,
}) => (
  <>
    {subTitle && (
      <p className="text-sm leading-[17.50px]">
        {typeof subTitle === 'string' ? <FormattedMessage id={subTitle} /> : <>{subTitle}</>}
      </p>
    )}
    {title && (
      <div className={cn('items-baseline gap-2 lg:flex lg:gap-3', classNames)}>
        {renderTitle({
          title: typeof title === 'string' ? <FormattedMessage id={title} /> : title,
          attributes: {
            className: cn(
              smallerFont
                ? 'tracking-wide text-2xl leading-[30px] font-mindset'
                : 'tracking-wider lg:leading-[51px] font-normal text-2xl lg:text-[40px] leading-[30px] font-mindset'
            ),
          },
          shouldBeH1,
        })}
        {extraElement}
      </div>
    )}
  </>
);

export default Headline;
